<head>
    <link rel="stylesheet" href="https://use.typekit.net/ahw0mno.css"></link>
    <link rel="stylesheet" href="https://use.typekit.net/ahw0mno.css"></link>
</head>

<template>
    <!-- <div id="backImage">
    </div> -->

    <v-carousel
      :cycle="false"
      height="100vh"
      >

        <template v-if="slideIndex < 2" v-slot:next="{ on, attrs }">
            <v-btn
                color="nextbutton"
                v-bind="attrs"
                v-on="on"
                @click= NextSlide(attrs)
                >
                Next
            </v-btn>
        </template>
        <template v-else v-slot:next="{ on, attrs }">
            <v-btn
                color="nextbutton"
                v-bind="attrs"
                v-on="on"
                @click= NextSlide(attrs)
                >
                Start
            </v-btn>
        </template>
        <v-carousel-item fade>
            <div id="backImage">
                <div class="content-box">
                    <div id="location-icon"></div>
                    <h2>Enable Location Access</h2>
                    <h3>To hear audio at the right time and place, please give Antelope Island Tours access to your location.</h3>
                </div>
            </div>
        </v-carousel-item>
        <v-carousel-item fade>
            <div id="backImage2">
                <div class="content-box">
                    <div id="gps-icon"></div>
                    <h2>GPS Autoplay</h2>
                    <h3>Focus on your surroundings, not the screen. Tours play automatically and include turn-by-turn direction.</h3>
                </div>
            </div>
        </v-carousel-item>
        <v-carousel-item fade>
            <div id="backImage3">
                <div class="content-box">
                    <h3 style="margin-top: 67px">Welcome to</h3>
                    <h1>Antelope Island State Park Audio Tour</h1>
                </div>
                <div id="bottomContent">
                    <h3 id="offCenter">Powered by</h3>
                    <img id="parkspassLogo" src="../assets/images/newParkspassLogo.svg" alt="logo">
                </div>
            </div>
        </v-carousel-item>
    </v-carousel>




</template>

<script>
    export default {
        data () {
            return {
                slideIndex: 0,
                sheet: false,
            }
        },
        created(){

        },
        methods: {
            NextSlide(s){
                this.slideIndex += 1;
                console.log(this.slideIndex)
                console.log(s);
                if (this.slideIndex == 3){
                    this.$router.push("/tour");
                }

            }
        }
    }
</script>

<style>
    #backImage{
        background-image: url(../assets/images/Setup1image.svg);
        background-size: cover;
        height: 100vh;
    }
    #backImage2{
        background-image: url(../assets/images/setup2.svg);
        background-size: cover;
        height: 100vh;
    }
    #backImage3{
        background-image: url(../assets/images/hiking3.svg);
        background-size: cover;
        height: 100vh;
    }
    #location-icon{
        background-image: url(../assets/images/location.svg);
        width: 48px;
        height: 48px;
        /* margin-top: 30px;
        margin-left: 20px; */
    }
    #gps-icon{
        background-image: url(../assets/images/gps.svg);
        width: 48px;
        height: 48px;
    }
    .content-box{
        position: absolute;
        top: 30px;
        left: 15px;
    }
    h1{
        color: white;
        font-size: 24px;
        font-family: pulpo, serif;
        line-height: 38px;
        font-weight: 400;
        width: 260px;
    }
    h2{
        color: white;
        font-size: 20px;
        line-height: 30px;
        font-family: pulpo, serif;
        font-weight: 700;
        margin: 10px 0px;
    }
    h3{
        color: white;
        font-size: 16px !important;
        line-height: 19.2px;
        font-family: lato, sans-serif;
        font-weight: 400;
        font-style: normal;
    }
    button{
        width: 90vw;
    }
    .v-window__prev{
        display: none;
    }
    .v-window__next{
        top: 215px;
    }
    .theme--dark.v-btn.v-btn--has-bg{
        background-color: #D79A02;
    }
    .v-carousel__controls{
        background: unset;
        bottom: unset;
        top: 248px;
    }
    #bottomContent{
        position: absolute;
        bottom: 0;
        margin-bottom: 150px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
    }
    #offCenter{
        position: absolute;
        bottom: 29px;
        left: 27%;
        font-family: pulpo, serif;
    }
    @media (max-width: 375px){
        #offCenter{
            left: 24%;
        }
    }
    @media (max-width: 320px){
        #offCenter{
            left: 20%;
        }
    }
</style>